module.exports = __webpack_public_path__ + "img/category-brand-hover.3c2dea05.png";